<template>
    <div>
        <div style="float:left;display: flex;width: 50px;">
            <el-popover
                    placement="bottom-start"
                    width="200"
                    trigger="hover">
                <el-card class="box-card">
                    <div slot="header" class="clearfix" style="text-align:center;height: 35px;margin-top: 15px;color: red">
                        <span><i class="el-icon-check"></i>当前账套：{{accountName}}</span>
                    </div>
                    <div style="cursor:pointer;" v-for="(item,index) in accountList" :key="index" class="text item" @click="changeAccount(item)">
                        账套{{index+1}}：{{item.accountName}}
                    </div>
                </el-card>
                <i class="el-icon-tickets" slot="reference" title="账套信息"
                   style="line-height: 50px;font-size: 30px; color: white"></i>
            </el-popover>
        </div>
        <div style="float:left;color:white;width: 30px;">
            |
        </div>
    </div>
</template>

<script>

    export default {
        name: "Account",
        components:{
        },
        data() {
            return {
                accountList: this.$store.state.loginInfo.accountList,
                accountName: this.$store.state.loginInfo.account.accountName,
            }
        },
        methods: {
            async changeAccount(item){
                //let path="/main"
                this.$confirm('即将切换账套, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async() => {

                    let accountId = item.accountId;
                    this.accountName = item.accountName;

                    let param = {
                        url:"/main/changeAccount",
                        param: {
                            accountId:accountId
                        }
                    }
                    const accountRes = await this.$store.dispatch( 'pubMethod', param);
                    if(accountRes.data.flag) {
                        this.$router.go(0);
                    } else{
                        await this.$router.push('/login');
                    }
                    //this.$router.push({path: '/main/changeAccount'})
                });
            },
            clickMsg(){
                this.$emit('clickMsg');
            },
            refreshWork(){
                this.$emit('refreshWork');
            }
        },
    }
</script>


<style scoped lang="scss">
    .text {
        font-size: 14px;
        text-align: left;
        margin-left: 20px;
        margin-top: 10px;
    }

    .item {
        margin-bottom: 18px;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }
    .clearfix:after {
        clear: both
    }

</style>
